// work data

export const Work = [
  {
    id: 1,
    name: "Reservia",
    description: "Intégrer une maquette en html et css ",
    tags: ["Html", "css"],
    imgSrc:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQWJxI4ZhVrTnyRHMrE0TP2bEtco5if5_XW3A&usqp=CAU",
    demo: "https://stoyann-open-classrooms.github.io/StoyannVelten_2_05112020/",
    github:
      "https://github.com/stoyann-open-classrooms/StoyannVelten_2_05112020",
  },
  {
    id: 2,
    name: "Ohmyfood",
    description: "Dynamiser une page web avec des animations CSS",
    tags: ["Html", "Sass"],
    imgSrc:
      "https://user.oc-static.com/upload/2020/08/24/15982605908418_Maquettes%20Ohmyfood.jpg",
    demo: "https://stoyann-open-classrooms.github.io/-stoyann-open-classrooms-StoyannVelten_3_03012021/",
    github:
      "https://github.com/stoyann-open-classrooms/-stoyann-open-classrooms-StoyannVelten_3_03012021",
  },
  {
    id: 3,
    name: "Game on",
    description: "Créer une landing page avec Javascript",
    tags: ["javascript"],
    imgSrc:
      "https://user.oc-static.com/upload/2021/12/15/16395717662959_HomePage.png",
    demo: "https://stoyann-open-classrooms.github.io/StoyannVelten_4_24022021/starterOnly/",
    github:
      "https://github.com/stoyann-open-classrooms/StoyannVelten_4_24022021",
  },
  {
    id: 4,
    name: "Fisheye",
    description: "Créer un site accessible pour une plateforme de photographes",
    tags: ["Html", "Sass", "Javascript"],
    imgSrc:
      "https://user.oc-static.com/upload/2020/08/18/15977571210897_image2.png",
    demo: "https://stoyann-open-classrooms.github.io/-StoyannVelten_6_15062021/",
    github:
      "https://github.com/stoyann-open-classrooms/-StoyannVelten_6_15062021",
  },
  {
    id: 5,
    name: "Les petits plats",
    description: "Développer un algorithme de recherche en JavaScript",
    tags: ["Sass", "Javascript", "POO"],
    imgSrc:
      "https://repository-images.githubusercontent.com/431645569/492a04e5-baca-4432-895f-2efbe85f7362",
    demo: "https://stoyann-open-classrooms.github.io/Stoyann_Velten_p7_19_08_2021/",
    github:
      "https://github.com/stoyann-open-classrooms/Stoyann_Velten_p7_19_08_2021",
  },
  {
    id: 6,
    name: "Dashboard Covid ",
    description:
      "Site dashboard reprenant les chiffres liés à l'épidémie de Covid19 (Mobile)",
    tags: ["Html", "Sass", "Javascript"],
    imgSrc:
      "https://th.bing.com/th/id/OIP.gXGCnWIUSB5NIAaBQzWFCQHaD9?pid=ImgDet&rs=1",
    demo: "https://stoyann-open-classrooms.github.io/covid-day-data-nc/#section-sannitaire",
    github: "https://github.com/stoyann-open-classrooms/covid-day-data-nc",
  },
  {
    id: 7,
    name: "Les arbres remarquables ",
    description: "Les arbres remarquables en Nouvelle-Calédonie",
    tags: ["Html", "SASS", "Javascript"],
    imgSrc:
      "https://th.bing.com/th/id/OIP.EDWNM7VKarAvWiSJ23UGywHaFg?pid=ImgDet&rs=1",
    demo: "https://stoyann-open-classrooms.github.io/les-arbres-remarquables/",
    github:
      "https://github.com/stoyann-open-classrooms/les-arbres-remarquables",
  },
  {
    id: 8,
    name: "Gym Yonos",
    description: "Site statique pour une salle de musculation fictive ",
    tags: ["Html", "SASS", "Javascript"],
    imgSrc:
      "https://www.stephanelima.fr/dossier-html/gymnase/ressources/img4-equip.jpg",
    demo: "https://stoyann-open-classrooms.github.io/salle-de-gym-fictive-gymYonos/",
    github:
      "https://github.com/stoyann-open-classrooms/salle-de-gym-fictive-gymYonos",
  },
];
